module.exports = __webpack_public_path__ + "img/camera-lens.c68293b7.svg";